import { IDropdown } from '@app/shared/interfaces/dropdown';

export enum ADDITIONAL_HEALTH_PREFERENCES {
  'Feeding tube' = 1,
  'Blood transfusion' = 2,
  'Pain medications' = 3,
  'Other' = 4,
}

export const ADDITIONAL_HEALTH_PREFERENCES_DROPDOWN: IDropdown<string>[] = Object.values(ADDITIONAL_HEALTH_PREFERENCES)
  .filter((value) => isNaN(Number(value)) === true)
  .map((value) => ({ value: `${ADDITIONAL_HEALTH_PREFERENCES[value]}`, label: value } as IDropdown<string>));
